import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const t = setTimeout(() => {
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    }, 150);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5cf87cea6ddddc7de43183dfbee92da1.jpg"
          alt="Table Privé — Private dining experience"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/25 to-black/65" />
      </div>

      <div
        ref={ref}
        className="absolute inset-0 flex flex-col justify-end pb-20 md:pb-28 px-8 md:px-20 transition-all duration-1200 ease-out"
        style={{ opacity: 0, transform: "translateY(18px)" }}
      >
        <div className="w-full">
          <div className="flex items-center gap-4 mb-7">
            <div className="h-px w-8 bg-[#C9A961]" />
            <span className="text-[#C9A961] tracking-[0.3em] text-[10px] uppercase font-light">
              London
            </span>
          </div>

          <h1 className="font-serif text-white text-[clamp(2.8rem,6vw,6rem)] leading-[1.05] font-light max-w-3xl mb-10">
            Private dining,<br />
            <em className="italic text-[#E8DCC8]">redefined.</em>
          </h1>

          <Link
            to="/inquiry"
            className="inline-flex items-center gap-3 border border-white/50 text-white text-[10px] tracking-[0.25em] uppercase font-light px-8 py-4 hover:border-white hover:bg-white/10 transition-all duration-400 cursor-pointer whitespace-nowrap"
          >
            Request an Experience
          </Link>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 right-10 flex flex-col items-center gap-3 opacity-40">
        <span className="text-white text-[9px] tracking-[0.3em] uppercase font-light" style={{ writingMode: "vertical-rl" }}>
          Scroll
        </span>
        <div className="w-px h-10 bg-white/50" />
      </div>
    </section>
  );
}
